// DeploymentLogsPage.js
import React, { useState } from "react";
import { Box } from "@mui/material";
import SimplePageHeader from "./Components/Navigation/SimplePageHeader";
import InfoBanner from "./Components/Navigation/InfoBanner";
import DeploymentLogsGrid from "./Components/MonitorDeployments/DeploymentLogsGrid";

const DeploymentLogsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (term) => {
    setSearchTerm(term);
  };

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <SimplePageHeader
        iconName="logs"
        titleString="Deployment Logs"
        showAddButton={false}
        onSearchChange={handleSearchChange}
        searchTerm={searchTerm}
      />
      <InfoBanner
        message="This page provides insights into the deployment logs and allows you to monitor and analyze deployment statuses for different machines."
        localStorageKey="deployment-logs-info" // Unique key for this page
      />
      <Box sx={{ padding: "20px" }}>
        <DeploymentLogsGrid searchTerm={searchTerm} />
      </Box>
    </Box>
  );
};

export default DeploymentLogsPage;
